// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","703":"LazyIdentificationBusinessForm","886":"LazyInvitationStep","954":"LazyBusinessInfoFormComponent"}[chunkId] + "." + {"99":"70e16385162d6ab8a905","703":"d0857a1c80dc314ddc17","886":"2613cfef6e796d79a96f","954":"0b6730b8118e8a2c4161"}[chunkId] + ".js";
};